/* ap-pg-pages.js — 文字頁共用 M0 進場（IO 觸發；reduced-motion／無 IO＝全顯不動）
   2026-08-24 文字頁窗建立。各 ap-pg-* section 以 defer 引用；重複引用同 src 只執行一次。
   2026-08-26 追加 header 捲動隱藏（cowboy 式）→ 2026-10-07 WO-1007-s7-9 退役（主題原生 scroll-up へ）。 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header 捲動隱藏は WO-1007-s7-9（2026-10-07）で退役＝Horizon 原生 enable_sticky_header: scroll-up に統一 */

  /* ---- M0 捲動進場 ---- */
  if (!('IntersectionObserver' in window)) return;
  if (reduce) return;
  document.documentElement.classList.add('appg-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  var targets = document.querySelectorAll('[data-appg-reveal]');
  /* 2026-08-31 Jack実機回報(技術頁STEP輪播):手機輪播(.ap-car)の非首卡はIO交集矩形が
     祖先overflowでclipされ閾値に届かず「下滑過半まで透明」。正解=首頁ap-motion.jsと同修:
     手機輪播内の首卡以外はreveal対象外=即顕。桌機gridは逐卡delay不変。 */
  var apMobileCar = window.matchMedia('(max-width: 734px)').matches;
  targets.forEach(function (el, i) {
    var car = el.closest('.ap-car');
    if (apMobileCar && car && car.querySelector('[data-appg-reveal]') !== el) { el.classList.add('is-in'); return; }
    el.style.transitionDelay = Math.min(i % 4 * 80, 240) + 'ms';
    io.observe(el);
  });
  /* 保險絲：IO 異常環境下 4 秒內未進場的元素強制全顯，內容永不隱形 */
  setTimeout(function () {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  }, 4000);
})();
